<template>
  <div class="table-input">
    <el-input-number
      v-if="isNumber"
      v-model="model"
      @change="$emit('change', $event)"
      @focus="show = false"
      @blur="show = true"
      ref="input"
    />
    <el-input
      v-else
      v-model="model"
      @change="$emit('change', $event)"
      @focus="show = false"
      @blur="show = true"
      ref="input"
    ></el-input>
    <span
      v-show="showError && show && !model"
      class="error-message text-danger"
      @click="errorClick"
    >
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: 'TableInput',

  props: {
    value: {
      type: null,
      required: true
    },
    showError: Boolean,
    isNumber: Boolean
  },

  watch: {
    value: {
      handler (value) {
        this.model = value
      },
      immediate: true
    }
  },

  data () {
    return {
      model: '',
      show: true
    }
  },

  methods: {
    errorClick () {
      const input = this.$refs.input
      if (input) {
        input.focus()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .table-input {
    position: relative;
  }
  .error-message {
    position: absolute;
    top: 0;
    left: 0;
  }
</style>
